import { usePage } from "@inertiajs/vue3";
import { ref } from "vue";

// Ported from www (types loosened to `any`): read a site setting by key from
// the shared `site.settings` prop.
export function useSetting(_props?: any) {
    const props = ref(_props ?? usePage().props);

    const getSetting = function (key: string, _default: any = null) {
        const settings = (props.value as any)?.site?.settings ?? [];
        const siteSetting = settings.find((val: any) => val?.setting?.key === key);

        if (siteSetting) {
            return siteSetting.value ?? siteSetting.setting?.default ?? _default;
        }

        return _default;
    };

    return { getSetting };
}
